import 'css-chunksrc/client/scenes/projectGroupCreation/groupCreationForm/resourcesList/resource/styles.scss';export default {
  "resource": "_resource_1lo1f_1",
  "icon": "_icon_1lo1f_26",
  "removeResourceIconContainer": "_removeResourceIconContainer_1lo1f_38"
};